// extracted by mini-css-extract-plugin
var _1 = "WhiteCardModal__buttons--DYjqp";
var _2 = "WhiteCardModal__content--E5sjI";
var _3 = "WhiteCardModal__dialogRegion--EZD1P";
var _4 = "WhiteCardModal__subtext--XwFsA CoreGeneral__roboto--UlmjE";
var _5 = "WhiteCardModal__title--CEiG2 CoreGeneral__robotoSlab--X8lgW";
var _6 = "WhiteCardModal__whiteCard--R1jgr";
export { _1 as "buttons", _2 as "content", _3 as "dialogRegion", _4 as "subtext", _5 as "title", _6 as "whiteCard" }
